export default __webpack_public_path__ + "static/media/tabletScreen.d728c3eb.png";